import * as fetch from '@/utils/action'
import { getTotalNumber } from '../totalMethod'
export default {
  getSampleBoardList (ctx, data) {
    return fetch.getSampleBoardList(data).then(res => {
      let result = getTotalNumber(res)
      return result
    })
  },
  getActionReason  (ctx, data) {
    return fetch.getActionReason(data).then(res => {
      return res.data
    })
  },
  getSampleBoardDetail (ctx, data) {
    return fetch.getSampleBoardDetail(data).then(res => {
      return res.data
    })
  },
  getSampleBoardStatusUpdate (ctx, data) {
    return fetch.getSampleBoardStatusUpdate(data).then(res => {
      return res
    })
  },
  getSamplePlatesOrders (ctx, data) {
    return fetch.getSamplePlatesOrders(data).then(res => {
      let result = getTotalNumber(res)
      return result
    })
  },
  getSamplePlatesReview (ctx, data) {
    return fetch.getSamplePlatesReview(data).then(res => {
      return res.data
    })
  },
  getSamplePlatesUpload (ctx, data) {
    return fetch.getSamplePlatesUpload(data).then(res => {
      return res
    })
  },
  getSpecialOrderCountPlate (ctx, data) {
    return fetch.getSpecialOrderCountPlate(data).then(res => {
      return res.data
    })
  },
  getSamplePlatesExcel (ctx, data) {
    return fetch.getSamplePlatesExcel(data).then(res => {
      let message = '请稍后到“导出历史”页面查看'
      return message
    })
  },
  uploadBatchImages (ctx, data) {
    return fetch.uploadBatchImages(data).then(res => {
      return res.data
    })
  },
  getSamplePlatesProcess (ctx, data) {
    return fetch.getSamplePlatesProcess(data).then(res => {
      return res.data
    })
  }
}
